import styled from 'styled-components';
import type { StarFill } from '.';

export const StarSvg = styled.svg<{ $fill: StarFill }>`
  display: block;
  flex-shrink: 0;

  .star-outline {
    fill: none;
    stroke: var(--outline-primary);
  }

  .star-fill {
    fill: var(--fill-brand);
    stroke: var(--fill-brand);
  }

  .star-half {
    stroke: var(--outline-primary);
  }

  .star-fill-stop {
    stop-color: var(--fill-brand);
  }

  .star-fill-stop-transparent {
    stop-color: var(--fill-brand);
    stop-opacity: 0;
  }
`;
